export default {
  title: {
    'zh-cn': '设备管理',
    'zh-tw': '設備管理',
    'en': 'Device Management'
  },
  list: {
    'zh-cn': '设备列表',
    'zh-tw': '設備列表',
    'en': 'Device List'
  },
  add: {
    'zh-cn': '新增设备',
    'zh-tw': '新增設備',
    'en': 'Add Device'
  },
  edit: {
    'zh-cn': '编辑设备',
    'zh-tw': '編輯設備',
    'en': 'Edit Device'
  },
  delete: {
    'zh-cn': '删除设备',
    'zh-tw': '刪除設備',
    'en': 'Delete Device'
  },
  import: {
    'zh-cn': '导入设备',
    'zh-tw': '導入設備',
    'en': 'Import Device'
  },
  export: {
    'zh-cn': '导出设备',
    'zh-tw': '導出設備',
    'en': 'Export Device'
  },
  deviceType: {
    'zh-cn': '设备类型',
    'zh-tw': '設備類型',
    'en': 'Device Type'
  },
  deviceName: {
    'zh-cn': '设备名称',
    'zh-tw': '設備名稱',
    'en': 'Device Name'
  },
  deviceStatus: {
    'zh-cn': '设备状态',
    'zh-tw': '設備狀態',
    'en': 'Device Status'
  },
  online: {
    'zh-cn': '在线',
    'zh-tw': '在線',
    'en': 'Online'
  },
  offline: {
    'zh-cn': '离线',
    'zh-tw': '離線',
    'en': 'Offline'
  },
  batchImportSuccess: {
    'zh-cn': '批量设备已成功导入，请刷新设备列表查看！',
    'zh-tw': '批量設備已成功導入，請刷新設備列表查看！',
    'en': 'Batch devices imported successfully, please refresh the device list to view!'
  },
  // 表单标签
  deviceSNLabel: {
    'zh-cn': '设备SN',
    'zh-tw': '設備SN',
    'en': 'Device SN'
  },
  status: {
    'zh-cn': '状态',
    'zh-tw': '狀態',
    'en': 'Status'
  },
  fourGStatus: {
    'zh-cn': '4G状态',
    'zh-tw': '4G狀態',
    'en': '4G Status'
  },
  fourGInfoIccid: {
    'zh-cn': 'ICCID',
    'zh-tw': 'ICCID',
    'en': 'ICCID'
  },
  fourGInfoModuleName: {
    'zh-cn': '4G模块类型',
    'zh-tw': '4G模組類型',
    'en': '4G Module Type'
  },
  fourGInfoPidAndvid: {
    'zh-cn': '4G模块编码',
    'zh-tw': '4G模組編碼',
    'en': '4G Module Code'
  },
  deviceMode: {
    'zh-cn': '设备模式',
    'zh-tw': '設備模式',
    'en': 'Device Mode'
  },
  // 占位符
  pleaseInput: {
    'zh-cn': '请输入',
    'zh-tw': '請輸入',
    'en': 'Please input'
  },
  pleaseSelect: {
    'zh-cn': '请选择',
    'zh-tw': '請選擇',
    'en': 'Please select'
  },
  // 按钮
  bind: {
    'zh-cn': '绑定',
    'zh-tw': '綁定',
    'en': 'Bind'
  },
  batchOperate: {
    'zh-cn': '批量操作',
    'zh-tw': '批量操作',
    'en': 'Batch Operate'
  },
  exitBatch: {
    'zh-cn': '退出批量',
    'zh-tw': '退出批量',
    'en': 'Exit Batch'
  },
  batchUpgrade: {
    'zh-cn': '批量升级',
    'zh-tw': '批量升級',
    'en': 'Batch Upgrade'
  },
  batchEdit: {
    'zh-cn': '批量编辑',
    'zh-tw': '批量編輯',
    'en': 'Batch Edit'
  },
  batchDivideGroups: {
    'zh-cn': '批量分组',
    'zh-tw': '批量分組',
    'en': 'Batch Divide Groups'
  },
  batchUnbind: {
    'zh-cn': '批量解绑',
    'zh-tw': '批量解綁',
    'en': 'Batch Unbind'
  },
  deployWhitelist: {
    'zh-cn': '下发白名单',
    'zh-tw': '下發白名單',
    'en': 'Deploy Whitelist'
  },
  // 表格列
  serialNumber: {
    'zh-cn': '序号',
    'zh-tw': '序號',
    'en': 'No.'
  },
  deviceSN: {
    'zh-cn': '设备SN',
    'zh-tw': '設備SN',
    'en': 'Device SN'
  },
  firmwareVersion: {
    'zh-cn': '固件版本',
    'zh-tw': '固件版本',
    'en': 'Firmware Version'
  },
  firmwareUpgradeStatus: {
    'zh-cn': '固件最后升级状态',
    'zh-tw': '固件最後升級狀態',
    'en': 'Firmware Last Upgrade Status'
  },
  appVersion: {
    'zh-cn': 'APP版本',
    'zh-tw': 'APP版本',
    'en': 'APP Version'
  },
  appUpgradeStatus: {
    'zh-cn': 'APP最后升级状态',
    'zh-tw': 'APP最後升級狀態',
    'en': 'APP Last Upgrade Status'
  },
  belongGroup: {
    'zh-cn': '所属分组',
    'zh-tw': '所屬分組',
    'en': 'Belong Group'
  },
  deviceIP: {
    'zh-cn': '设备IP',
    'zh-tw': '設備IP',
    'en': 'Device IP'
  },
  region: {
    'zh-cn': '所在地区',
    'zh-tw': '所在地區',
    'en': 'Region'
  },
  channel: {
    'zh-cn': '通道',
    'zh-tw': '通道',
    'en': 'Channel'
  },
  authStatus: {
    'zh-cn': '认证状态',
    'zh-tw': '認證狀態',
    'en': 'Auth Status'
  },
  lastOnlineTime: {
    'zh-cn': '最后上线时间',
    'zh-tw': '最後上線時間',
    'en': 'Last Online Time'
  },
  lastOfflineTime: {
    'zh-cn': '最后离线时间',
    'zh-tw': '最後離線時間',
    'en': 'Last Offline Time'
  },
  typeCode: {
    'zh-cn': '类型编码',
    'zh-tw': '類型編碼',
    'en': 'Type Code'
  },
  remark: {
    'zh-cn': '备注',
    'zh-tw': '備註',
    'en': 'Remark'
  },
  operation: {
    'zh-cn': '操作',
    'zh-tw': '操作',
    'en': 'Operation'
  },
  // 操作提示
  remoteDevice: {
    'zh-cn': '远程设备',
    'zh-tw': '遠程設備',
    'en': 'Remote Device'
  },
  videoPreview: {
    'zh-cn': '视频预览',
    'zh-tw': '視頻預覽',
    'en': 'Video Preview'
  },
  unbind: {
    'zh-cn': '解绑',
    'zh-tw': '解綁',
    'en': 'Unbind'
  },
  editButton: {
    'zh-cn': '修改',
    'zh-tw': '修改',
    'en': 'Edit'
  },
  upgrade: {
    'zh-cn': '升级',
    'zh-tw': '升級',
    'en': 'Upgrade'
  },
  more: {
    'zh-cn': '更多',
    'zh-tw': '更多',
    'en': 'More'
  },
  manualTimeSync: {
    'zh-cn': '手动校时',
    'zh-tw': '手動校時',
    'en': 'Manual Time Sync'
  },
  manualOssIssue: {
    'zh-cn': '手动下发OSS',
    'zh-tw': '手動下發OSS',
    'en': 'Manual OSS Issue'
  },
  fourGOpen: {
    'zh-cn': '4G开通',
    'zh-tw': '4G開通',
    'en': 'Enable 4G'
  },
  fourGClose: {
    'zh-cn': '4G关闭',
    'zh-tw': '4G關閉',
    'en': 'Disable 4G'
  },
  // 消息提示
  unbindSuccess: {
    'zh-cn': '解绑成功',
    'zh-tw': '解綁成功',
    'en': 'Unbind successful'
  },
  // 消息提示
  issueOssSuccess: {
    'zh-cn': '下发OSS成功',
    'zh-tw': '下發OSS成功',
    'en': 'issueOss successful'
  },
  updateStatusSuccess: {
    'zh-cn': '更新状态成功',
    'zh-tw': '更新狀態成功',
    'en': 'update successful'
  },
  noDevId: {
    'zh-cn': '无devId',
    'zh-tw': '無devId',
    'en': 'No devId'
  },
  noFourGSwitch: {
    'zh-cn': '该设备不支持4G开关功能',
    'zh-tw': '該設備不支持4G開關功能',
    'en': 'This device does not support 4G switching'
  },
  noActivate4GPermission: {
    'zh-cn': '无开通4G控件权限',
    'zh-tw': '無開通4G控件權限',
    'en': 'No permission to manage 4G activation'
  },
  deviceUnbindSuccess: {
    'zh-cn': '设备解绑成功',
    'zh-tw': '設備解綁成功',
    'en': 'Device unbind successful'
  },
  fourGOpenSuccess: {
    'zh-cn': '4G开通操作下发设备成功，请稍后刷新查看',
    'zh-tw': '4G開通操作下發設備成功，請稍後刷新查看',
    'en': '4G enable command was sent to the device successfully. Refresh later to check the result.'
  },
  fourGCloseSuccess: {
    'zh-cn': '4G关闭操作下发设备成功，请稍后刷新查看',
    'zh-tw': '4G關閉操作下發設備成功，請稍後刷新查看',
    'en': '4G disable command was sent to the device successfully. Refresh later to check the result.'
  },
  upgradeFailed: {
    'zh-cn': '升级失败！',
    'zh-tw': '升級失敗！',
    'en': 'Upgrade failed!'
  },
  contactSupport: {
    'zh-cn': '请联系技术支持',
    'zh-tw': '請聯繫技術支持',
    'en': 'Please contact technical support'
  },
  failReason: {
    'zh-cn': '失败原因：',
    'zh-tw': '失敗原因：',
    'en': 'Fail reason: '
  },
  upgradeNote: {
    'zh-cn': '（注：如已在其他途径升级成功请忽略）',
    'zh-tw': '（注：如已在其他途徑升級成功請忽略）',
    'en': '(Note: Please ignore if already upgraded successfully through other means)'
  },
  upgrading: {
    'zh-cn': '设备正在升级中，请稍后！',
    'zh-tw': '設備正在升級中，請稍後！',
    'en': 'Device is upgrading, please wait!'
  },
  // 确认对话框
  unbindConfirm: {
    'zh-cn': '当前选中设备 {count} 台设备,设备解绑后您需要重新绑定才能操作此设备，您确定执行此操作？',
    'zh-tw': '當前選中設備 {count} 台設備,設備解綁後您需要重新綁定才能操作此設備，您確定執行此操作？',
    'en': 'Currently selected {count} device(s). After unbinding, you need to rebind to operate this device. Are you sure to proceed?'
  },
  unbindConfirmSingle: {
    'zh-cn': '设备解绑后您需要重新绑定才能操作此设备，您确定执行此操作？',
    'zh-tw': '設備解綁後您需要重新綁定才能操作此設備，您確定執行此操作？',
    'en': 'After unbinding, you need to rebind to operate this device. Are you sure to proceed?'
  },
  fourGOpenConfirm: {
    'zh-cn': '确认开通该设备的4G功能吗？',
    'zh-tw': '確認開通該設備的4G功能嗎？',
    'en': 'Are you sure you want to enable 4G for this device?'
  },
  fourGCloseConfirm: {
    'zh-cn': '确认关闭该设备的4G功能吗？',
    'zh-tw': '確認關閉該設備的4G功能嗎？',
    'en': 'Are you sure you want to disable 4G for this device?'
  },
  batchAlgorithmModel: {
    'zh-cn': '批量切换算法模型',
    'zh-tw': '批量切換演算法模型',
    'en': 'Switch algorithm version'
  },
  algorithmModelSwitch: {
    'zh-cn': '切换算法版本',
    'zh-tw': '切換演算法版本',
    'en': 'Switch algorithm version'
  },
  algorithmModelDialogTitle: {
    'zh-cn': '算法版本',
    'zh-tw': '演算法版本',
    'en': 'Algorithm version'
  },
  algorithmModelGeneric: {
    'zh-cn': '通用版本',
    'zh-tw': '通用版本',
    'en': 'Generic version'
  },
  algorithmModelLarge: {
    'zh-cn': '大模型版本',
    'zh-tw': '大模型版本',
    'en': 'Large model version'
  },
  algorithmModelSwitchRiskTip: {
    'zh-cn': '*换算法模型后，设备会复位（重启），请谨慎操作！',
    'zh-tw': '*換演算法模型後，設備會復位（重啟），請謹慎操作！',
    'en': '*After changing the algorithm model, the device will reset (reboot). Proceed with caution!'
  },
  noAlgorithmModelPermission: {
    'zh-cn': '无修改设备算法模型控件权限',
    'zh-tw': '無修改設備演算法模型控件權限',
    'en': 'No permission to change device algorithm model'
  },
  algorithmModelUpdateSuccess: {
    'zh-cn': '算法版本切换操作下发设备成功，请稍后刷新查看',
    'zh-tw': '演算法版本切換操作下發設備成功，請稍後刷新查看',
    'en': 'Algorithm version change was sent to the device successfully. Refresh later to check the result.'
  },
  algorithmModelDeviceNotSupported: {
    'zh-cn': '当前设备不支持切换算法版本',
    'zh-tw': '當前設備不支持切換演算法版本',
    'en': 'This device does not support switching algorithm version'
  },
  // 其他
  selectedCount: {
    'zh-cn': '已选择',
    'zh-tw': '已選擇',
    'en': 'Selected'
  },
  sameTypeSelectAll: {
    'zh-cn': '同型号全选',
    'zh-tw': '同型號全選',
    'en': 'Select All Same Type'
  },
  versionDescription: {
    'zh-cn': '版本描述',
    'zh-tw': '版本描述',
    'en': 'Version Description'
  },
  batchOperateTip: {
    'zh-cn': '点击【批量操作】按钮选择设备进行升级',
    'zh-tw': '點擊【批量操作】按鈕選擇設備進行升級',
    'en': 'Click [Batch Operate] button to select devices for upgrade'
  },
  // 添加设备对话框
  bindDevice: {
    'zh-cn': '绑定设备',
    'zh-tw': '綁定設備',
    'en': 'Bind Device'
  },
  singleAdd: {
    'zh-cn': '单台添加',
    'zh-tw': '單台添加',
    'en': 'Single Add'
  },
  multipleAdd: {
    'zh-cn': '多台添加',
    'zh-tw': '多台添加',
    'en': 'Multiple Add'
  },
  organization: {
    'zh-cn': '组织机构',
    'zh-tw': '組織機構',
    'en': 'Organization'
  },
  deviceAccount: {
    'zh-cn': '设备账号',
    'zh-tw': '設備賬號',
    'en': 'Device Account'
  },
  devicePassword: {
    'zh-cn': '设备密码',
    'zh-tw': '設備密碼',
    'en': 'Device Password'
  },
  sipProtocol: {
    'zh-cn': 'SIP传输协议',
    'zh-tw': 'SIP傳輸協議',
    'en': 'SIP Transport Protocol'
  },
  sipProtocolTooltip: {
    'zh-cn': '国标视频SIP信令传输协议',
    'zh-tw': '國標視頻SIP信令傳輸協議',
    'en': 'National Standard Video SIP Signaling Transport Protocol'
  },
  channelNumber: {
    'zh-cn': '通道号',
    'zh-tw': '通道號',
    'en': 'Channel Number'
  },
  uploadFile: {
    'zh-cn': '上传文件',
    'zh-tw': '上傳文件',
    'en': 'Upload File'
  },
  clickUpload: {
    'zh-cn': '点击上传',
    'zh-tw': '點擊上傳',
    'en': 'Click to Upload'
  },
  downloadTemplate: {
    'zh-cn': '示例文件下载',
    'zh-tw': '示例文件下載',
    'en': 'Download Template'
  },
  bindDeviceTemplate: {
    'zh-cn': '绑定设备导入模板.xlsx',
    'zh-tw': '綁定設備導入模板.xlsx',
    'en': 'Bind Device Import Template.xlsx'
  },
  whitelistTemplate: {
    'zh-cn': '车牌白名单模板.xlsx',
    'zh-tw': '車牌白名單模板.xlsx',
    'en': '车牌白名单模板.xlsx'
  },
  // 表单验证消息
  pleaseInputDeviceSN: {
    'zh-cn': '请输入设备SN',
    'zh-tw': '請輸入設備SN',
    'en': 'Please input device SN'
  },
  deviceSNLengthLimit: {
    'zh-cn': '设备SN长度为32个字符以内',
    'zh-tw': '設備SN長度為32個字符以內',
    'en': 'Device SN length should be within 32 characters'
  },
  pleaseSelectOrganization: {
    'zh-cn': '请选择机构',
    'zh-tw': '請選擇機構',
    'en': 'Please select organization'
  },
  pleaseInputDeviceAccount: {
    'zh-cn': '请输入设备账号',
    'zh-tw': '請輸入設備賬號',
    'en': 'Please input device account'
  },
  deviceAccountLengthLimit: {
    'zh-cn': '设备账号长度为16个字符以内',
    'zh-tw': '設備賬號長度為16個字符以內',
    'en': 'Device account length should be within 16 characters'
  },
  pleaseInputDevicePassword: {
    'zh-cn': '请输入设备密码',
    'zh-tw': '請輸入設備密碼',
    'en': 'Please input device password'
  },
  channelNumberLengthLimit: {
    'zh-cn': '通道号长度限制为20个字符以内',
    'zh-tw': '通道號長度限制為20個字符以內',
    'en': 'Channel number length should be within 20 characters'
  },
  pleaseSelectChannelType: {
    'zh-cn': '请选择通道类型',
    'zh-tw': '請選擇通道類型',
    'en': 'Please select channel type'
  },
  pleaseInputChannelNumber: {
    'zh-cn': '请输入通道号',
    'zh-tw': '請輸入通道號',
    'en': 'Please input channel number'
  },
  pleaseInputRemark: {
    'zh-cn': '请输入备注',
    'zh-tw': '請輸入備註',
    'en': 'Please input remark'
  },
  // 消息提示
  bindSuccess: {
    'zh-cn': '绑定成功',
    'zh-tw': '綁定成功',
    'en': 'Bind successful'
  },
  fileUploadedWaitResult: {
    'zh-cn': '文件已上传，请等待处理结果',
    'zh-tw': '文件已上傳，請等待處理結果',
    'en': 'File uploaded, please wait for processing result'
  },
  fileUploadFailed: {
    'zh-cn': '文件上传失败，请重试',
    'zh-tw': '文件上傳失敗，請重試',
    'en': 'File upload failed, please try again'
  },
  pleaseUploadWhitelistFile: {
    'zh-cn': '请上传白名单文件',
    'zh-tw': '請上傳白名單文件',
    'en': 'Please upload whitelist file'
  },
  pleaseSelectDevice: {
    'zh-cn': '请选择设备',
    'zh-tw': '請選擇設備',
    'en': 'Please select device'
  },
  whitelistDeploySuccess: {
    'zh-cn': '白名单已下发，请前往设备端查看',
    'zh-tw': '白名單已下發，請前往設備端查看',
    'en': 'Whitelist deployed. Please check on the device.'
  },
  whitelistDeployFailed: {
    'zh-cn': '白名单下发失败，请重试',
    'zh-tw': '白名單下發失敗，請重試',
    'en': 'Whitelist deployment failed. Please try again.'
  },
  requestFailed: {
    'zh-cn': '请求失败',
    'zh-tw': '請求失敗',
    'en': 'Request failed'
  },
  // 编辑设备
  editDevice: {
    'zh-cn': '修改设备',
    'zh-tw': '修改設備',
    'en': 'Edit Device'
  },
  editSuccess: {
    'zh-cn': '修改成功',
    'zh-tw': '修改成功',
    'en': 'Edit successful'
  },
  // 批量编辑
  batchEditDevice: {
    'zh-cn': '批量修改设备',
    'zh-tw': '批量修改設備',
    'en': 'Batch Edit Device'
  },
  selectedDevices: {
    'zh-cn': '已选设备（台）',
    'zh-tw': '已選設備（台）',
    'en': 'Selected Devices'
  },
  submittingData: {
    'zh-cn': '正在提交数据，请稍后',
    'zh-tw': '正在提交數據，請稍後',
    'en': 'Submitting data, please wait'
  },
  batchEditSuccess: {
    'zh-cn': '批量修改成功',
    'zh-tw': '批量修改成功',
    'en': 'Batch edit successful'
  },
  batchEditFailed: {
    'zh-cn': '批量修改失败',
    'zh-tw': '批量修改失敗',
    'en': 'Batch edit failed'
  },
  // 批量分组
  selectGroup: {
    'zh-cn': '选择分组',
    'zh-tw': '選擇分組',
    'en': 'Select Group'
  },
  pleaseSelectGroup: {
    'zh-cn': '请选择分组',
    'zh-tw': '請選擇分組',
    'en': 'Please select group'
  },
  batchDivideGroupsSuccess: {
    'zh-cn': '批量分组成功',
    'zh-tw': '批量分組成功',
    'en': 'Batch divide groups successful'
  },
  batchDivideGroupsFailed: {
    'zh-cn': '批量分组失败',
    'zh-tw': '批量分組失敗',
    'en': 'Batch divide groups failed'
  },
  // 设备分组
  groupList: {
    'zh-cn': '分组列表',
    'zh-tw': '分組列表',
    'en': 'Group List'
  },
  pleaseInputKeyword: {
    'zh-cn': '请输入关键字搜索',
    'zh-tw': '請輸入關鍵字搜索',
    'en': 'Please input keyword to search'
  },
  createGroup: {
    'zh-cn': '创建分组',
    'zh-tw': '創建分組',
    'en': 'Create Group'
  },
  groupId: {
    'zh-cn': '分组Id',
    'zh-tw': '分組Id',
    'en': 'Group ID'
  },
  groupName: {
    'zh-cn': '分组名称',
    'zh-tw': '分組名稱',
    'en': 'Group Name'
  },
  pleaseInputGroupId: {
    'zh-cn': '请输入分组Id',
    'zh-tw': '請輸入分組Id',
    'en': 'Please input group ID'
  },
  pleaseInputGroupName: {
    'zh-cn': '请输入分组名称',
    'zh-tw': '請輸入分組名稱',
    'en': 'Please input group name'
  },
  pleaseInputSn: {
    'zh-cn': '设备SN',
    'zh-tw': '设备SN',
    'en': 'Device SN'
  },
  groupNameLengthLimit: {
    'zh-cn': '分组名称长度为32个字符以内',
    'zh-tw': '分組名稱長度為32個字符以內',
    'en': 'Group name length should be within 32 characters'
  },
  deleteGroupConfirm: {
    'zh-cn': '删除此分组后，此分组下的设备将全部变为未分组设备，您确定要执行此操作吗?',
    'zh-tw': '刪除此分組後，此分組下的設備將全部變為未分組設備，您確定要執行此操作嗎?',
    'en': 'After deleting this group, all devices under this group will become ungrouped. Are you sure to proceed?'
  },
  deleteSuccess: {
    'zh-cn': '删除成功',
    'zh-tw': '刪除成功',
    'en': 'Delete successful'
  },
  addSuccess: {
    'zh-cn': '添加成功',
    'zh-tw': '添加成功',
    'en': 'Add successful'
  },
  // 批量升级
  upgradeDevice: {
    'zh-cn': '升级设备',
    'zh-tw': '升級設備',
    'en': 'Upgrade Device'
  },
  upgradeType: {
    'zh-cn': '升级类型',
    'zh-tw': '升級類型',
    'en': 'Upgrade Type'
  },
  selectVersion: {
    'zh-cn': '选择版本',
    'zh-tw': '選擇版本',
    'en': 'Select Version'
  },
  setTime: {
    'zh-cn': '设定时间',
    'zh-tw': '設定時間',
    'en': 'Set Time'
  },
  pleaseSelectUpgradeType: {
    'zh-cn': '请选择升级包类型',
    'zh-tw': '請選擇升級包類型',
    'en': 'Please select upgrade package type'
  },
  pleaseSelectVersion: {
    'zh-cn': '请选择版本',
    'zh-tw': '請選擇版本',
    'en': 'Please select version'
  },
  pleaseSetUpgradeTime: {
    'zh-cn': '请设定升级时间',
    'zh-tw': '請設定升級時間',
    'en': 'Please set upgrade time'
  },
  comboPackage: {
    'zh-cn': '组合包(APP+固件)',
    'zh-tw': '組合包(APP+固件)',
    'en': 'Combo Package (APP+Firmware)'
  },
  firmwareUpgradePackage: {
    'zh-cn': '固件升级包',
    'zh-tw': '固件升級包',
    'en': 'Firmware Upgrade Package'
  },
  customUpgradePackage: {
    'zh-cn': '二开升级包',
    'zh-tw': '二開升級包',
    'en': 'Custom Upgrade Package'
  },
  pleaseUpgradeFirmware: {
    'zh-cn': '请升级固件版本',
    'zh-tw': '請升級固件版本',
    'en': 'Please upgrade firmware version'
  },
  appUpgradePackage: {
    'zh-cn': 'APP升级包',
    'zh-tw': 'APP升級包',
    'en': 'APP Upgrade Package'
  },
  customUpgradePackageVersion: {
    'zh-cn': '二开升级包版本',
    'zh-tw': '二開升級包版本',
    'en': 'Custom Upgrade Package Version'
  },
  // 视频预览
  videoPreviewTitle: {
    'zh-cn': '视频预览',
    'zh-tw': '視頻預覽',
    'en': 'Video Preview'
  },
  previewOnlyLowQuality: {
    'zh-cn': '（预览只支持省流画质）',
    'zh-tw': '（預覽只支持省流畫質）',
    'en': '(Preview only supports low quality)'
  },
  connecting: {
    'zh-cn': '连接中...',
    'zh-tw': '連接中...',
    'en': 'Connecting...'
  },
  // 手动校时
  manualTimeSyncTitle: {
    'zh-cn': '手动校时',
    'zh-tw': '手動校時',
    'en': 'Manual Time Sync'
  },
  pleaseSelectTime: {
    'zh-cn': '请选择时间',
    'zh-tw': '請選擇時間',
    'en': 'Please select time'
  },
  timeSyncTip: {
    'zh-cn': '默认时间是当前系统时间，可能与设备所属时区的时间不一致。\n请确保您手动输入或确认的时间是设备所属时区的当前时间，以避免校时错误',
    'zh-tw': '默認時間是當前系統時間，可能與設備所屬時區的時間不一致。\n請確保您手動輸入或確認的時間是設備所屬時區的當前時間，以避免校時錯誤',
    'en': 'The default time is the current system time, which may not match the time of the device\'s timezone.\nPlease ensure that the time you manually input or confirm is the current time of the device\'s timezone to avoid time sync errors'
  },
  // 升级计划提示
  pendingUpgradeTask: {
    'zh-cn': '待执行升级任务',
    'zh-tw': '待執行升級任務',
    'en': 'Pending Upgrade Task'
  },
  cancelTask: {
    'zh-cn': '取消任务',
    'zh-tw': '取消任務',
    'en': 'Cancel Task'
  },
  executionTime: {
    'zh-cn': '执行时间：',
    'zh-tw': '執行時間：',
    'en': 'Execution Time: '
  },
  parameterError: {
    'zh-cn': '参数错误， 请刷新重试',
    'zh-tw': '參數錯誤， 請刷新重試',
    'en': 'Parameter error, please refresh and try again'
  },
  cancelSuccess: {
    'zh-cn': '取消成功',
    'zh-tw': '取消成功',
    'en': 'Cancel successful'
  },
  pleaseSelectSameDeviceType: {
    'zh-cn': '您只能选择相同产品型号的设备',
    'zh-tw': '您只能選擇相同產品型號的設備',
    'en': 'You can only select devices of the same product model'
  },
  notSupportTips: {
    'zh-cn': '【{deviceType}】类型的设备不支持的远程升级',
    'zh-tw': '【{deviceType}】類型的設備不支援的遠程升級',
    'en': 'Devices of type [{deviceType}] do not support remote upgrade'
  },
  // 批量配置
  batchConfig: {
    'zh-cn': '批量配置',
    'zh-tw': '批量配置',
    'en': 'Batch Config'
  },
  configDevice: {
    'zh-cn': '配置设备',
    'zh-tw': '配置設備',
    'en': 'Config Device'
  },
  configIni: {
    'zh-cn': '配置INI',
    'zh-tw': '配置INI',
    'en': 'Config INI'
  },
  selectConfigVersion: {
    'zh-cn': '选择ini',
    'zh-tw': '選擇ini',
    'en': 'Select ini'
  },
  pleaseSelectConfigVersion: {
    'zh-cn': '请选择配置版本',
    'zh-tw': '請選擇配置版本',
    'en': 'Please select config version'
  },
  pleaseSetConfigTime: {
    'zh-cn': '请设定配置时间',
    'zh-tw': '請設定配置時間',
    'en': 'Please set config time'
  },
  configType: {
    'zh-cn': '配置方式',
    'zh-tw': '配置方式',
    'en': 'Config Type'
  },
  pleaseSelectConfigType: {
    'zh-cn': '请选择配置方式',
    'zh-tw': '請選擇配置方式',
    'en': 'Please select config type'
  },
  uploadIniFile: {
    'zh-cn': '上传ini文件',
    'zh-tw': '上傳ini文件',
    'en': 'Upload ini file'
  },
  selectExistingConfig: {
    'zh-cn': '选择已有配置包',
    'zh-tw': '選擇已有配置包',
    'en': 'Select existing config'
  },
  pleaseUploadIniFile: {
    'zh-cn': '请上传ini文件',
    'zh-tw': '請上傳ini文件',
    'en': 'Please upload ini file'
  },
  // 任务列表
  taskList: {
    'zh-cn': '任务列表',
    'zh-tw': '任務列表',
    'en': 'Task List'
  },
  deviceConfigTask: {
    'zh-cn': '设备配置任务',
    'zh-tw': '設備配置任務',
    'en': 'Device Configuration Task'
  },
  setStartTime: {
    'zh-cn': '设定开始时间',
    'zh-tw': '設定開始時間',
    'en': 'Set Start Time'
  },
  setEndTime: {
    'zh-cn': '设定结束时间',
    'zh-tw': '設定結束時間',
    'en': 'Set End Time'
  },
  completed: {
    'zh-cn': '已完成',
    'zh-tw': '已完成',
    'en': 'Completed'
  },
  notCompleted: {
    'zh-cn': '未完成',
    'zh-tw': '未完成',
    'en': 'Not Completed'
  },
  all: {
    'zh-cn': '全部',
    'zh-tw': '全部',
    'en': 'All'
  },
  creationTime: {
    'zh-cn': '创建时间',
    'zh-tw': '創建時間',
    'en': 'Creation Time'
  },
  startTime: {
    'zh-cn': '开始时间',
    'zh-tw': '開始時間',
    'en': 'Start Time'
  },
  completionTime: {
    'zh-cn': '完成时间',
    'zh-tw': '完成時間',
    'en': 'Completion Time'
  },
  transmissionStatus: {
    'zh-cn': '传送状态',
    'zh-tw': '傳送狀態',
    'en': 'Transmission Status'
  },
  retry: {
    'zh-cn': '重试',
    'zh-tw': '重試',
    'en': 'Retry'
  },
  retrySuccess: {
    'zh-cn': '重试成功',
    'zh-tw': '重試成功',
    'en': 'Retry successful'
  }
}

